export enum PayChannel {
    ApplePay = 1,
    Paypal = 2,
    Card = 3,   //sc信用卡
    Google = 4,
    GooglePayNew = 5,
    Crypto = 6,
    CashApp = 8,
    QIWI = 9,
    ApplePayCard = 10,
    CashAppCard = 11,
    YooMoney = 12,
    GIROPAY = 13,
    TRUSTLY = 14,
    SKRILL = 15,
    Xsolla = 16,
    VenmoPaypal = 17,
    AfterPay = 18,
}